
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Történet',
	'noDashboardFound': 'A történet nem kérhető le. Már nem létezik, vagy nem rendelkezik a megfelelő jogosultságokkal a megtekintéséhez.',
	'noDashboardCapability': 'Nem jogosult történetek használatára',
	'noDashboardPermision': 'Nincs megfelelő jogosultsága a történet megtekintéséhez',
	'defaultName': 'Új történet',
	'storyProperties': 'Eset tulajdonságai',
	'createAvDataStoryLabel': 'Történet',
	'createAvSlideShowLabel': 'Diavetítés',
	'createAvPanAndZoomLabel': 'Kalauz',
	'dashboard_save_success': 'A rendszer mentette a történetet.',
	'cmEmptySelection': 'A történet törölve lett. Próbálja meg új történetként menteni.',
	'createStoryTitle': 'Történet létrehozása',
	'transitionStyleTitle': 'Átmenet stílusa',
	'createButton': 'Létrehozás',
	'cancelButton': 'Mégse',
	'dashboardResetTitle': 'Történet visszaállítása',
	'dashboardResetMessage': 'Biztosan vissza kívánja állítani az erre a történetre alkalmazott összes módosítást?',
	'dashboardResetToast': 'A rendszer visszaállította a történetet.',
	'filter_drag_and_drop_all_tabs': 'Húzza ide az adatokat az összes jelentben történő szűréshez.',
	'filter_drag_and_drop_current_tab': 'Húzza ide az adatokat az aktuális jelenetben történő szűréshez.',
	'filterIconLabel_Global': 'Minden jelenet',
	'filterIconLabel_Tab': 'Ez a jelenet',
	'filterIconTooltip_Global': 'Minden jelenet',
	'filterIconTooltip_Tab': 'Ez a jelenet',
	'filterOverflowMenu_Global': 'Összes jelenet túlcsordulásmenü',
	'filterOverflowMenu_Tab': 'Aktuális jelenet túlcsordulásmenü',
	'renameScene': 'Jelenet átnevezése',
	'duplicateScene': 'Jelenet többszörözése',
	'deleteScene': 'Jelenet törlése',
	'editTimelineHighlight': 'Kiemelés szerkesztése',
	'deleteTimelineHighlight': 'Kiemelés törlése',
	'filter_includesAll': 'Összes tartalmazása',
	'timeline_highlight_moved_to': 'A(z) %{id} idősor kiemelés áthelyezve ide: %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Kijelölés',
	'newDefaultStoryName': 'Történet: %{modelName}',
	'exportLabel': 'Mentés',
	'exportAsLabel': 'Mentés másként:',
	'exportDialogTitle': 'Mentés történetként',
	'exportDialogFooter': 'Mentés és Mégse gomb',
	'loadAfterExportLabel': 'Történet megnyitása mentés után',
	'selectTemplateLabel': 'Sablon kiválasztása',
	'outOfBoundsWarningMessage': 'Az exportálás után egyes műszerfal felületi elemek kívül esnek a rácson, és nem jeleníthetők meg megfelelően.',
	'emptyExploreCardsWarningMessage': 'A történetként mentés során az üres kártyák törlésre kerültek.',
	'dashboard_export_success': 'A műszerfal sikeresen mentésre került történetként.',
	'explore_export_success': 'A böngészés sikeresen mentésre került történetként.',
	'toastUpgradeDone': 'A rendszer frissítette a történetet. Az optimális teljesítmény fenntartása érekében most mentse azt.',
	'navigationMarker': 'Navigációs jelző',
	'navigateMarkers': 'Navigációs jelzők',
	'navNextMarker': 'Következő jelző',
	'navPrevMarker': 'Előző jelző',
	'navPrevMarkerAbbreviated': 'El. jelző',
	'timelineSettingsButton': 'Visszajátszási beállítások',
	'autoPlay': 'Minden jelenet lejátszása',
	'loop': 'Végtelen ciklus',
	'refreshData': 'Frissítés indításkor',
	'slideshowLabel': 'Diavetítés',
	'panAndZoomLabel': 'Kalauz',
	'slideShowLayoutLabel': 'Diavetítési elrendezés',
	'panAndZoomLayoutLabel': 'Kalauz elrendezés',
	'panAndZoomLayoutFooter': 'A kalauz elrendezés egyetlen vásznon lévő jelenetek gyűjteménye. Amikor ilyen típusú történetet futtat, a bemutató sorrendben közelít rá és pásztáz végig az egyes önálló jeleneteken. Ez különbözik a diavetítés elrendezéstől, ahol mindegyik jelenet új vásznon van bemutatva. A vonalakkal összekötött, három jelenetből álló kalauz elrendezéssel jelenetek vízszintes sorozatát hozhatja létre. Ez idősor megjelenítésekor hasznos.',
	'PanAndZoomLayout1': '5 jelenet négyszögletes formába rendezve',
	'PanAndZoomLayout2': '4 jelenet balról jobbra emelkedő lépcsőzetes formába rendezve',
	'PanAndZoomLayout3': '6 jelenet négyszögletes formába rendezve',
	'PanAndZoomLayout4': '7 jelenet négyszögletes formába rendezve, 6 kis jelenettel felül és 1 naggyal alul',
	'PanAndZoomLayout5': '3 jelenet elrendezve: 2 kis jelenet felül és 1 nagy jelenet alul',
	'PanAndZoomLayout6': '4 jelenet vízszintes elrendezésben',
	'pageSelectWarning': 'Jelöljön ki egy jelenetet.',
	'noSceneTransitionLabel': 'Nincs',
	'sceneTransitionPropertyLabel': 'Jelenetátmenet',
	'animatedPathSceneTransitionLabel': 'Animált útvonal',
	'sweepSceneTransitionLabel': 'Pásztázás',
	'storyTypeLabel': 'Történet típusa',
	'layoutLabel': 'Elrendezés',
	'tabName_animation': 'Animáció',
	'propAniAnimation': 'Animáció',
	'propAniTypeEntrance': 'Megjelenés animációja',
	'propAniDirectionIn': 'Megjelenés iránya',
	'propAniTypeExit': 'Kilépés animációja',
	'propAniDirectionOut': 'Kilépés iránya',
	'propAniDirection': 'Irány',
	'propAniEntrance': 'Megjelenés',
	'propAniTypeEntranceSlideIn': 'Becsúsztatás',
	'propAniTypeEntranceFadeIn': 'Fokozatos megjelenítés',
	'propAniTypeEntrancePivotIn': 'Forgatás befelé',
	'propAniTypeEntranceScaleIn': 'Léptékezett megjelenítés',
	'propAniTypeEntranceShrinkIn': 'Zsugorítás befelé',
	'propAniDirectionInLeft': 'Balról',
	'propAniDirectionInRight': 'Jobbról',
	'propAniDirectionInTop': 'Felülről',
	'propAniDirectionInBottom': 'Alulról',
	'propAniExit': 'Kilépés',
	'propAniTypeExitSlideIn': 'Kicsúsztatás',
	'propAniTypeExitFadeIn': 'Fokozatos eltűnés',
	'propAniTypeExitPivotOut': 'Forgatás kifelé',
	'propAniTypeExitScaleIn': 'Léptékezett eltűnés',
	'propAniTypeExitExpandOut': 'Bővítés kifelé',
	'propAniDirectionOutLeft': 'Balra',
	'propAniDirectionOutRight': 'Jobbra',
	'propAniDirectionOutTop': 'Felülre',
	'propAniDirectionOutBottom': 'Alulra',
	'propAniEntranceTime': 'Kezdés időpontja (másodperc):',
	'propAniExitTime': 'Befejezés időpontja (másodperc):',
	'animationNoEntranceText': 'A belépő animációra nem kerül sor, ha a felületi elem a jelenet elején van.',
	'animationNoExitText': 'A kilépő animációra nem kerül sor, ha a felületi elem a jelenet végén van.',
	'propAniTypeDataEntrance': 'Adatok kezdete',
	'propAniRevealDuration': 'Belépő animáció időtartama',
	'timelineAnimationProperties': 'Animáció tulajdonságainak megnyitása',
	'scenesPropertiesSection': 'Jelenetek',
	'editStoryCoachMarkTitle': 'Történet szerkesztése',
	'editStoryCoachMarkContents': 'Kattintson a Ceruza ikonra a történet szerkesztéséhez.',
	'addDataStoryCoachMarkContents': 'Húzzon át adatokat az adatpanelről a történetre.',
	'expandSceneCoachmarkTitle': 'Idősor megnyitása',
	'expandSceneCoachmarkContents': 'Jelenet animálásához állítsa be az objektum láthatóságát az idő és az időtartam alapján.',
	'overviewCoachmarkTitle': 'Áttekintő jelenetek',
	'overviewCoachmarkContents': 'A története elején és végén az áttekintő jelenetekkel jelenítheti meg az összes jelenet átfogó képét. Egy áttekintő jelenetben kattintással és húzással cserélheti fel a jeleneteket egymással. Megjelenítheti és elrejtheti az áttekintő jeleneteket a történet tulajdonságaiban.',
	'animatedPathCoachmarkTitle': 'Animált útvonal',
	'animatedPathCoachmarkContents': 'Egy objektum animáláshoz az egyik jelenetből a másikba, többszörözzön egy jelenetet egy objektummal. Ezután helyezze át, méretezze át vagy forgassa el a duplikált objektumot az új jeleneten.',
	'propShowStoryOverviewFirstSlide': 'Az összes jelenet megjelenítése az elején',
	'propShowStoryOverviewLastSlide': 'Az összes jelenet megjelenítése a végén',
	'storySceneSingleCountLabel': '1 jelenet',
	'storySceneCountLabel': '%{count} jelenet',
	'storySceneRangeCountLabel': '%{index} / %{count} jelenet',
	'storySceneExpand': 'Idősor megnyitása',
	'storySceneActionMenu': 'Indítójelenet beállítások menü',
	'timelineRightContainerLabel': 'Idősor gomb vezérlőelem-csoport',
	'timelineViewLabel': 'Idősor',
	'timelineZoomFit': 'Mérethez igazítás',
	'timelineZoomIn': 'Nagyítás',
	'timelineZoomOut': 'Kicsinyítés',
	'timelinePositionIndicator': 'idősor pozíciójelző: %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'idősor pozíciójelző mozgatása balra eddig: %{position}',
	'timelinePositionIndicatorMoveRightTo': 'idősor pozíciójelző mozgatása jobbra eddig: %{position}',
	'sceneStart': 'Ugrás a jelenet elejére a(z) %{position} pozícióra',
	'sceneEnd': 'Ugrás a jelenet végére a(z) %{position} pozícióra',
	'timelineHighlightTitle': 'Kiemelés',
	'addTimelineHighlight': 'Kiemelés hozzáadása',
	'addSceneBtnTitle': 'Új jelenet hozzáadása alapértelmezett sablonnal',
	'addSceneChevronBtnTitle': 'Jelenetsablon kiválasztása',
	'timelinePlay': 'Lejátszás',
	'timelinePause': 'Szüneteltetés',
	'sceneNavigation': 'Navigálás a jelenetben',
	'navNextScene': 'Következő jelenet',
	'navPrevScene': 'Előző jelenet',
	'navPrevSceneAbbreviated': 'Előző jelenet',
	'navExitFullScreen': 'Kilépés a teljes képernyős módból',
	'navToggleOverview': 'Áttekintés váltása',
	'rowNumber': '%{number}. sor',
	'overviewBtnLabel': 'Áttekintés',
	'sceneListStart': 'Áttekintés kezdete',
	'sceneListEnd': 'Áttekintés vége',
	'timelineLeftHandle': '%{name} bal oldali fogópontja',
	'timelineRightHandle': '%{name} jobb oldali fogópontja',
	'timelineLeftHandleNoTitle': 'bal oldali fogó',
	'timelineRightHandleNoTitle': 'jobb oldali fogó',
	'timelineMoveLeft': '%{object} mozgatása balra',
	'timelineMoveRight': '%{object} mozgatása jobbra',
	'timelineMoveWidget': 'az idősor felületi elem áthelyezve a következő időpontokra: %{newStartTime} - %{newEndTime}',
	'timelineMoveWidgetStartTime': 'az idősor felületi elem kezdési időpontja a következőre módosult: %{newStartTime}',
	'timelineMoveWidgetEndTime': 'az idősor felületi elem befejezési időpontja a következőre módosult: %{newEndTime}',
	'timelineMoveWidgetDown': 'az idősor felületi elem lejjebb került',
	'timelineMoveWidgetUp': 'az idősor felületi elem feljebb került',
	'addSceneTitle': 'Jelenet hozzáadása',
	'blankSceneLayout': 'Üres',
	'titleSceneLayout': 'Cím és alcím',
	'sceneLayout1': 'Cím és egy megjelenítés melletti szöveg',
	'sceneLayout2': 'Cím és egy megjelenítés',
	'sceneLayout3': 'Cím és két megjelenítés',
	'sceneLayout4': 'Többcélú',
	'sceneLayout5': 'Nincs cím egy megjelenítés melletti szöveggel',
	'sceneLayout6': 'Többcélú 2 x 2',
	'sceneLayout7': 'Többcélú 2 1 mellett',
	'sceneLayout8': 'Többcélú 1 2 mellett',
	'sceneLayout9': 'Többcélú 1 2 felett',
	'sceneLayout10': 'Többcélú 2 1 felett',
	'sceneLayout11': 'Többcélú 4 1 felett',
	'sceneLayout12': 'Többcélú 1 1 felett 2 mellett x 2 1 felett',
	'titleWidgetPlaceholderText': 'Ide írja be a címet',
	'subtitleWidgetPlaceholderText': 'Ide írja be az alcímet',
	'createStoryViewTitle': 'Történet létrehozása',
	'defaultStoryName': 'Új történet',
	'screenshot_label': 'Történet: %{title}',
	'screenshot_label_scene': 'Jelenet: %{sceneTitle}, történet: %{title}',
	'filmstripHandleOpenLabel': 'Jelenetválasztó megnyitása',
	'filmstripHandleCloseLabel': 'Jelenetválasztó bezárása'
});
